// @deprecated — the module-level `timeout` makes this unsafe for concurrent
// inputs (every caller shares the same timer). For React inputs prefer the
// `useDebouncedValue` hook in /hooks/useDebouncedValue.js. This export is
// kept for backwards-compatibility with non-React callers.
let timeout

export const debounce = (callBack, delay = 1000) => {
    return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => callBack(...args), delay)
    }
}